import React from "react";
import styled from "styled-components";
import naoConcedidoPqn from "../../assets/naoConcedidoPqn.png";
import concedidoPqn from "../../assets/concedido-pequeno.png";
import emAnalisePqn from "../../assets/em-analise-pequeno.png";
import publicaFederalPqn from "../../assets/publicar-federal-pq.png";
import publicaEstadualPqn from "../../assets/publicar-estadual-pq.png";
import particularPrivadaPqn from "../../assets/particular-privado-pq.png";

const Container = styled.div`
  font-family: Public Sans;
  max-width: 1500px;
  text-align: center;
  border-top: 1px solid #ccc;
  background-color: #F2F0F0;
  display: flex;
  padding: 10px;
  padding-left: 30px;
  margin-left: 10px;
  gap: 30px; 
`;

const Bloco = styled.div`
  display: flex;
  align-items: center; 
  gap: 8px; 
`;

const Elementos = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #555555;
`;

const Status = () => {
  return (
    <Container>
      <Bloco>
        <img src={concedidoPqn} alt="Concedido" />
        <Elementos>Concedido</Elementos>
      </Bloco>
      <Bloco>
        <img src={naoConcedidoPqn} alt="Não concedido" />
        <Elementos>Não Concedido</Elementos>
      </Bloco>
      <Bloco>
        <img src={emAnalisePqn} alt="Para Análise" />
        <Elementos>Para Análise</Elementos>
      </Bloco>
      <Bloco>
        <img src={publicaFederalPqn} alt="Escola Pública Federal" />
        <Elementos>Escola Pública Federal</Elementos>
      </Bloco>
      <Bloco>
        <img src={publicaEstadualPqn} alt="Escola Pública Estadual" />
        <Elementos>Escola Pública Estadual</Elementos>
      </Bloco>
      <Bloco>
        <img src={particularPrivadaPqn} alt="Escola Particular Privada" />
        <Elementos>Escola Particular Privada</Elementos>
      </Bloco>
    </Container>
  );
};

export default Status;